<template>
    <header class="bg-white flex items-center justify-between shadow-md">
      <Sheet v-model:open="isSheetOpen">
        <SheetTrigger class="block md:hidden"><Menu /></SheetTrigger>
        <SheetContent side="left" class="sheet-content">
          <SheetHeader>
            <SheetTitle>Навигация</SheetTitle>
            <SheetDescription class="mt-4">
              <nav class="flex flex-col space-y-2">
                <!-- Main navigation items -->
                <router-link 
                  to="/" 
                  class="flex items-center p-2 rounded-md hover:bg-gray-100 transition-colors"
                  @click="closeSheet"
                >
                  <Home class="mr-2 h-5 w-5" />
                  Главная
                </router-link>
                
                <!-- Collapsible Partners menu -->
                <div>
                  <button 
                    class="flex items-center justify-between w-full p-2 rounded-md hover:bg-gray-100 transition-colors"
                    @click="togglePartners"
                  >
                    <span class="flex items-center">
                      <Building class="mr-2 h-5 w-5" />
                      Партнеры
                    </span>
                    <ChevronDown 
                      class="h-5 w-5 transition-transform" 
                      :class="{ 'transform rotate-180': partnersExpanded }" 
                    />
                  </button>
                  <div 
                    v-show="partnersExpanded" 
                    class="pl-8 pt-1 pb-2 space-y-1.5"
                  >
                    <router-link 
                      to="/partners" 
                      class="block p-1.5 rounded-md hover:bg-gray-100 transition-colors"
                      @click="closeSheet"
                    >
                      Список партнеров
                    </router-link>
                    <router-link 
                      to="/partners/create" 
                      class="block p-1.5 rounded-md hover:bg-gray-100 transition-colors"
                      @click="closeSheet"
                    >
                      Создать партнера
                    </router-link>
                  </div>
                </div>
                
                <!-- Other navigation items -->
                <router-link 
                  to="/contact" 
                  class="flex items-center p-2 rounded-md hover:bg-gray-100 transition-colors"
                  @click="closeSheet"
                >
                  <Mail class="mr-2 h-5 w-5" />
                  Контакты
                </router-link>
                
                <router-link 
                  to="/about" 
                  class="flex items-center p-2 rounded-md hover:bg-gray-100 transition-colors"
                  @click="closeSheet"
                >
                  <Info class="mr-2 h-5 w-5" />
                  О нас
                </router-link>
                
                <hr class="my-2 border-gray-200" />
                
                <router-link 
                  to="/profile" 
                  class="flex items-center p-2 rounded-md hover:bg-gray-100 transition-colors"
                  @click="closeSheet"
                >
                  <User class="mr-2 h-5 w-5" />
                  Профиль
                </router-link>
                
                <router-link 
                  to="/settings" 
                  class="flex items-center p-2 rounded-md hover:bg-gray-100 transition-colors"
                  @click="closeSheet"
                >
                  <Settings class="mr-2 h-5 w-5" />
                  Настройки
                </router-link>
              </nav>
            </SheetDescription>
          </SheetHeader>
        </SheetContent>
      </Sheet>
      <div class="flex items-center">
        <div @click="goHome" class="cursor-pointer px-2">
          <img src="@/assets/images/logo.png" alt="Logo" class="h-[40px] cursor-pointer" @click="goHome">
        </div>
        <Menubar class="hidden md:flex h-[50px] border-none shadow-none">
          <MenubarMenu class="b-0 shadow-none">
            <Button variant="ghost" class="h-[50px]"><Plus /> Добавить</Button>
          </MenubarMenu>
          <MenubarMenu class="b-0 shadow-none">
            <Button variant="ghost" class="h-[50px]">Объекты</Button>
          </MenubarMenu>
          <MenubarMenu >
            <MenubarTrigger class="h-[50px]">Партнеры</MenubarTrigger>
            <MenubarContent>
              <MenubarItem @click="() => router.push('/partners')">Список</MenubarItem>
              <MenubarItem @click="() => router.push('/partners/create')">Создать</MenubarItem>
            </MenubarContent>
          </MenubarMenu>
          <MenubarMenu>
            <MenubarTrigger class="h-[50px]">Справочники</MenubarTrigger>
            <MenubarContent>
              <MenubarItem @click="() => router.push('/dictionary/products')">Объекты</MenubarItem>
              <MenubarItem @click="() => router.push('/dictionary/packages')">Пакеты</MenubarItem>
              <MenubarSeparator />
              <MenubarItem @click="() => router.push('/dictionary/countries')">Страны</MenubarItem>
              <MenubarItem @click="() => router.push('/dictionary/cities')">Города</MenubarItem>
              <MenubarSeparator />
              <MenubarItem @click="() => router.push('/dictionary/units')">Единицы измерения</MenubarItem>
              <MenubarItem @click="() => router.push('/dictionary/currencies')">Валюты</MenubarItem>
            </MenubarContent>
          </MenubarMenu>
          <MenubarMenu>
            <MenubarTrigger class="h-[50px]">Настройки</MenubarTrigger>
            <MenubarContent>
              <MenubarItem @click="() => router.push('/dictionary/users')">Пользователи</MenubarItem>
              <MenubarItem @click="() => router.push('/dictionary/roles')">Роли</MenubarItem>
            </MenubarContent>
          </MenubarMenu>

        </Menubar>
      </div>

      <!-- Right Section: User Avatar -->
      <div class="flex items-center gap-4 pr-4">

            <!-- User Avatar with Dropdown -->
            <div class="relative group">
                <!-- User Avatar Button -->
                <button
                    @click="toggleDropdown"
                    class="flex items-center gap-2 px-3 py-2 bg-white hover:bg-gray-50 rounded-lg cursor-pointer"
                >
                    <div class="flex flex-col items-start">
                        <span class="text-sm font-medium text-gray-800">{{ authStore.user?.name }}</span>
                        <span class="text-xs text-gray-500">{{ roles }}</span>
                    </div>
                    <div class="flex items-center justify-center w-8 h-8 bg-[#EB2F96] rounded-full">
                        <img src="@/assets/icons/user.svg" alt="User" class="h-4 w-4" />
                    </div>
                </button>

                <!-- Dropdown Menu -->
                <div
                    v-if="isDropdownOpen"
                    class="absolute right-0 mt-2 w-48 bg-white rounded-lg shadow-lg py-2 z-10"
                    @mouseleave="closeDropdownDelayed"
                    @mouseenter="cancelCloseDropdown"
                >
                    <router-link to="/profile" class="block px-4 py-2 text-sm text-[#111111] hover:bg-[#F5F6F8]">
                        Профиль
                    </router-link>
                    <router-link to="/settings" class="block px-4 py-2 text-sm text-[#111111] hover:bg-[#F5F6F8]">
                        Настройки
                    </router-link>
                    <div class="border-t border-gray-100 my-1"></div>
                    <button @click="logout" class="block w-full text-left px-4 py-2 text-sm text-red-500 hover:bg-[#F5F6F8]">
                        Выйти
                    </button>
                </div>
            </div>
        </div>
    </header>
</template>

<script setup lang="ts">
import { ref, computed } from 'vue';
import { useRouter, useRoute } from 'vue-router';
import {
  NavigationMenu,
  NavigationMenuContent,
  NavigationMenuIndicator,
  NavigationMenuItem,
  NavigationMenuLink,
  NavigationMenuList,
  NavigationMenuTrigger,
  navigationMenuTriggerStyle,
  NavigationMenuViewport,
} from '@/components/ui/navigation-menu'
import {
  Sheet,
  SheetContent,
  SheetDescription,
  SheetHeader,
  SheetTitle,
  SheetTrigger,
} from '@/components/ui/sheet'
import Button from '@/components/ui/button/Button.vue';
import { useAuthStore } from '@/store/auth';
import { useDictionaryStore } from '@/store/dictionary';
import { useModalStore } from '@/store/modal'
import { useSettingsStore } from '@/store/settings'
import {
  Plus,
  Menu,
  Home,
  Building,
  ChevronDown,
  Mail,
  Info,
  User,
  Settings
} from 'lucide-vue-next'

import {
  Menubar,
  MenubarContent,
  MenubarItem,
  MenubarMenu,
  MenubarSeparator,
  MenubarShortcut,
  MenubarTrigger,
} from '@/components/ui/menubar'

const modal = useModalStore()
const authStore = useAuthStore();
const settingsStore = useSettingsStore();
const dictionaryStore = useDictionaryStore();
const router = useRouter();
const route = useRoute();
const isSheetOpen = ref(false)

// Workaround for Sheet component access
// This allows the navigation links to close the sheet when clicked
const closeSheet = (event: Event) => {
  isSheetOpen.value = false;
  // const sheetElement = (event.target as HTMLElement).closest('.sheet-content');
  // if (sheetElement) {
  //   const sheetInstance = (sheetElement as any).__vueParentComponent?.parent?.parent;
  //   if (sheetInstance && sheetInstance.open !== undefined) {
  //     sheetInstance.open = false;
  //   }
  // }
};

// Mobile menu state
const partnersExpanded = ref(false);
const togglePartners = () => {
  partnersExpanded.value = !partnersExpanded.value;
};

// Dropdown state
const isDropdownOpen = ref(false);
let closeTimer = null;

// Toggle dropdown menu
const toggleDropdown = () => {
  isDropdownOpen.value = !isDropdownOpen.value;
};

// Close dropdown with delay to allow movement to menu
const closeDropdownDelayed = () => {
  closeTimer = setTimeout(() => {
    isDropdownOpen.value = false;
  }, 150); // Short delay to allow cursor movement
};

// Cancel close if user moves cursor to menu
const cancelCloseDropdown = () => {
  if (closeTimer) {
    clearTimeout(closeTimer);
    closeTimer = null;
  }
};

const goHome = () => {
  router.push('/');
};

const roles = computed(() => {
  return dictionaryStore.dictionary.roles?.filter((role) => authStore.roles?.includes(role.label)).map((role) => role.name).join(', ')
})


const logout = () => {
  authStore.clearUser();
  authStore.clearTokens();
  dictionaryStore.clear();
  router.push('/auth/login');
};

</script>
